import { useAppContext } from "../context/AppContext";
import css from "./CustomMessage.module.css";

export default function CustomMessage() {
  const { options } = useAppContext();
  const message = options.custom_text?.message.trim();

  return message ? <p className={css["custom-message"]}>{message}</p> : null;
}
